import React, {useState} from "react";
import { useNavigate } from 'react-router-dom';
import VeryconVariants2 from "../../Assets/products_landing/dc controller variant png.png"
import VeryconVariants2Left from "../../Assets/products_landing/DCController2.png"
import DCController from "../../Assets/products_landing/DC Controller.webp"
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';
import Slider from 'react-slick';
import FormModal from "../ProductsLanding/FormModal";

import VeryconVariants2LeftNew from "../../Assets/products_landing/DC Controller Set Images.png"
import VeryconVariants2LeftModal from "../../Assets/products_landing/DC Controller Set ImagesLarge.png"


import VeryconVariants2LeftNew2 from "../../Assets/products_landing/DC Controller Images 2.png"

const VeryconDc = () => {
   const sliderSettings2 = {
  dots: true,
  infinite: true,
  arrows: true,
  autoplay: true,
  adaptiveHeight: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
      },
    },
  ],
};

    const navigate = useNavigate();
    const img = [
        { src: VeryconVariants2LeftNew },
        { src: VeryconVariants2LeftNew2 },
    ]
    const [productTitle, setProductTitle] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxImage, setLightboxImage] = useState(null);

    const openModal = () => {
        setIsModalOpen(true)
    };

    const openLightbox = () => {
        setLightboxOpen(true);
    };

    const closeLightbox = () => {
        setLightboxOpen(false);
    };
    React.useEffect(() => {
    const handleKeyDown = (e) => {
        if (e.key === 'Escape') closeLightbox();
    };
    if (lightboxOpen) {
        document.addEventListener('keydown', handleKeyDown);
    }
    return () => document.removeEventListener('keydown', handleKeyDown);
}, [lightboxOpen]);
    return (
        // <section className="bg-light-gradient-white blade-margin-top-sm">
        //     <div className="containers-min mx-auto px-4 py-12">
        //         <div className="2xl:pb-20 xl:pb-16 lg:pb-12 md:pb-8 pb-0">
        //             <h3 className="text-center font-gilroy">
        //                 AC Charger Controller - Verycon 2.0
        //             </h3>
        //             <p className="my-3 md:my-5 lg:my-7 text-center font-poppins font-light">
        //                 Presenting Verycon 2.0 Charger Controller, your pathway towards building intelligent triple gun EV Chargers! Build multi-faceted EVSEs with features that fulfill your product strategy.
        //             </p>
        //         </div>

        //         <div className="flex flex-col md:flex-row">
        //             <div className="w-full md:w-1/2">
        //                 <img src={VeryconVariants2} alt="VeryconVariants2" />
        //                 <div className="flex items-center py-2 sm:py-3 gap-3">
        //                     <div onClick={() => {
        //                         navigate('/get-in-touch')
        //                     }}>
        //                         <button
        //                             className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6'
        //                         >
        //                             <span className="flex justify-center items-center">
        //                                 <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
        //                                 <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
        //                             </span>
        //                             Get Quote
        //                         </button>
        //                         {/* <Button title="Contact Us" /> */}
        //                     </div>

        //                     <div className='group cursor-pointer'>
        //                         <a href="" target="_blank" className='text-gray-600'>
        //                             <button
        //                                 className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6'
        //                             >
        //                                 <span className="flex justify-center items-center">
        //                                     <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
        //                                     <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
        //                                 </span>
        //                                 Brochure
        //                             </button>
        //                         </a>
        //                     </div>
        //                 </div>
        //             </div>
        //             <div className="w-full md:w-1/2">
        //                 <div className="grow shrink flex justify-center items-center relative min-h-[300px] sm:min-h-[400px] md:min-h-[550px] lg:min-h-[650px] xxl:min-h-[800px]">
        //                     <div className="absolute top-0 left-auto bottom-0 right-0 bg-gradient w-32 md:w-56 lg:w-80"></div>
        //                     <div className="mx-3 md:w-10/12  md:max-w-[850px] max-w-sm grid place-content-center md:px-10 lg:px-20  bg-grey z-10 h-5/6 lg:h-4/5 rounded-3xl overflow-hidden relative ">
        //                         {/* <img
        //                         loading="lazy"
        //                         src={tabData[activeIdx].imgSrc}
        //                         alt={tabData[activeIdx].title}
        //                         className="mx-auto my-auto object-contain object-center lg:mb-10 z-10"
        //                     /> */}
        //                         <img src={VeryconVariants2Left} alt="VeryconVariants2" />
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </section >
        <section className="bg-light-gradient blade-margin-top-sm">
            <div className="2xl:pb-20 xl:pb-16 lg:pb-12 md:pb-8 pb-0 containers-min mx-auto">
                <h3 className="text-center font-gilroy">
                    DC Charger Controller - Verycon DC
                </h3>
                <p className="my-3 md:my-5 lg:my-7 text-center font-poppins font-light">
                    Own the flexibility to build your own dual gun CCS2 DC chargers with the Verycon DC
                    Controller. Designed for scalability, speed, and seamless integration into your custom
                    EVSE architecture
                </p>
            </div>
            <div className="flex xLg:flex-row flex-col-reverse gap-3 relative gap-y-6">
                <div className=" basis-32  xl:basis-20 grow shrink  col-end-7 flex items-center flex-col lg:justify-end px-3 pl-5 lg:pl-20 xl:pl-10">
                    <h5 className="font-semibold font-gilroy">DC Charger Output Configuration</h5>
                    <img src={VeryconVariants2} alt="VeryconVariants2" />
                    <div className="flex items-center py-2 sm:py-3 gap-3 w-full sm:w-2/3">
                        <div onClick={() => {
                            openModal()
                            setProductTitle("DC Charger Controller - Verycon DC")
                        }}>
                            <button
                                className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                            >
                                <span className="flex justify-center items-center">
                                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                </span>
                                Get Quote
                            </button>
                            {/* <Button title="Contact Us" /> */}
                        </div>

                        <div className='group cursor-pointer'>
                            <a href="https://resources.verdemobility.com/files/VeryconDC_V1.pdf" target="_blank" className='text-gray-600'>
                                <button
                                    className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                                >
                                    <span className="flex justify-center items-center">
                                        <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                        <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                    </span>
                                    Brochure
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
                 <div className="basis-80 grow shrink flex justify-center items-center relative min-h-[300px] sm:min-h-[400px] md:min-h-[550px] lg:min-h-[650px] xxl:min-h-[800px]">
                    {/* Right Gradient Background */}
                    <div className="absolute top-0 bottom-0 right-0 bg-gradient w-24 sm:w-32 md:w-56 lg:w-80 z-0"></div>

                    {/* Slider Container */}
                    <div className="relative z-10 bg-grey rounded-3xl overflow-hidden mx-3 w-full max-w-sm sm:max-w-md md:max-w-[850px] h-[90%] flex items-center justify-center px-4 sm:px-8 md:px-10 lg:px-20">
                        <Slider {...sliderSettings2} className="w-full  cursor-zoom-in">
                            {img.map((src, index) => (
                                <div key={index} className="text-center px-2">
                                    <p className="font-poppins text-lg font-medium mb-3">{src.title}</p>
                                    <img
                                        src={src.src}
                                        alt={`slide-${index}`}
                                        className="w-full max-h-[500px] object-contain mx-auto"
                                        onClick={() => { setLightboxOpen(true); setLightboxImage(src.src); }}
                                    />
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
                {/* <div className="basis-80 grow shrink flex justify-center items-center relative min-h-[300px] sm:min-h-[400px] md:min-h-[550px] lg:min-h-[650px] xxl:min-h-[800px]">
                    <div className="absolute top-0 left-auto bottom-0 right-0 bg-gradient w-32 md:w-56 lg:w-80"></div>

                    <div className="mx-3 md:w-10/12 md:max-w-[850px] max-w-sm grid place-content-center md:px-10 lg:px-20 bg-grey z-10 h-5/6 lg:h-4/5 rounded-3xl overflow-hidden relative">
                        <img
                            loading="lazy"
                            src={VeryconVariants2LeftNew}
                            alt="Verycon 2.0"
                            className="w-full h-full object-contain cursor-zoom-in transition-transform duration-200 hover:scale-[1.02]"
                            onClick={openLightbox}
                            title="Click to enlarge"
                        />
                    </div>
                </div> */}
            </div>

            {/* Lightbox Popup */}
            {lightboxOpen && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm"
                    onClick={closeLightbox}
                >
                    <div
                        className="relative max-w-[90vw]  max-h-[85vh] lg:max-w-[70vw] lg:max-h-[95vh] bg-white rounded-2xl shadow-2xl overflow-hidden p-1"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            onClick={closeLightbox}
                            className="absolute top-3 right-3 z-10 bg-black/60 hover:bg-black/80 text-white rounded-full w-9 h-9 flex items-center justify-center text-lg font-bold transition-colors duration-150"
                            aria-label="Close"
                        >
                            ✕
                        </button>
                        <img
                            src={lightboxImage}   
                            alt="Verycon DC - Full View"
                            className="w-screen h-screen object-contain rounded-xl"
                        />
                    </div>
                </div>
            )}

            {isModalOpen && <FormModal isModalOpen={isModalOpen} productTitle={productTitle} setIsModalOpen={setIsModalOpen} />}
        </section>
    );
};


export default VeryconDc;